"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inaccessibleZoneGeographyCustomValidation = exports.rangeOptionalOrValidCustomValidation = exports.remoteWorkDaysCustomValidation = exports.travelToPlaceCustomValidation = exports.transitFareCustomValidation = exports.householdHybridCarCountCustomValidation = exports.householdElectricCarCountCustomValidation = exports.getGeographyCustomValidation = exports.phoneOptionalCustomValidation = exports.emailOptionalCustomValidation = void 0;
const turf_1 = require("@turf/turf");
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const validations_1 = require("evolution-common/lib/services/widgets/validations/validations");
const surveyHelperNew = __importStar(require("evolution-common/lib/utils/helpers"));
const validations_2 = require("evolution-common/lib/services/widgets/validations/validations");
// FIXME Find a way to parameterize the inaccessible zones
const inaccessibleZones_json_1 = __importDefault(require("../geojson/inaccessibleZones.json"));
const quebecWaterWaysSimplified_json_1 = __importDefault(require("../geojson/quebecWaterWaysSimplified.json"));
// Check if email or phone number is provided
const emailOrPhoneNumberRequiredValidation = ({ contactEmail, phoneNumber }) => {
    return [
        {
            validation: (0, LodashExtensions_1._isBlank)(contactEmail) && (0, LodashExtensions_1._isBlank)(phoneNumber),
            errorMessage: {
                fr: 'L\'adresse courriel ou le numéro de téléphone est requis.',
                en: 'Email address or phone number is required.'
            }
        }
    ];
};
// Return the email validation (with email or phone number required).
// Cannot use the builtin `emailValidation` as the validation implies the field is required.
const emailOptionalCustomValidation = (value, customValue, interview, path) => {
    const contactEmail = value;
    const phoneNumber = surveyHelperNew.getResponse(interview, 'phoneNumber', null);
    const emailOrPhoneNumberRequired = emailOrPhoneNumberRequiredValidation({ contactEmail, phoneNumber }); // Check if email or phone number is provided
    // Validate email format
    const emailValidationMessages = [
        {
            validation: !(0, LodashExtensions_1._isBlank)(value) &&
                !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(value)),
            errorMessage: {
                fr: 'Le courriel est invalide.',
                en: 'Email is invalid'
            }
        }
    ];
    return [...emailOrPhoneNumberRequired, ...emailValidationMessages];
};
exports.emailOptionalCustomValidation = emailOptionalCustomValidation;
// Return the phone validation (with email or phone number required).
// Cannot use the builtin `phoneValidation` as the validation doesn't check the contact email.
const phoneOptionalCustomValidation = (value, customValue, interview, path) => {
    const contactEmail = surveyHelperNew.getResponse(interview, 'contactEmail', null);
    const phoneNumber = value;
    const phoneValidationMessages = (0, validations_2.phoneValidation)(value, customValue, interview, path); // Get the phone validation messages
    const emailOrPhoneNumberRequired = emailOrPhoneNumberRequiredValidation({ contactEmail, phoneNumber }); // Check if email or phone number is provided
    return [...emailOrPhoneNumberRequired, ...phoneValidationMessages];
};
exports.phoneOptionalCustomValidation = phoneOptionalCustomValidation;
// Return the validations for the geography
const getGeographyCustomValidation = ({ value, interview, path }) => {
    var _a;
    const geography = surveyHelperNew.getResponse(interview, path, null);
    const geocodingTextInput = geography ? (_a = geography.properties) === null || _a === void 0 ? void 0 : _a.geocodingQueryString : undefined;
    return [
        {
            validation: (0, LodashExtensions_1._isBlank)(value),
            errorMessage: {
                fr: 'Le positionnement du lieu est requis.',
                en: 'Positioning of the place is required.'
            }
        },
        {
            validation: geography &&
                geography.properties.lastAction &&
                (geography.properties.lastAction === 'mapClicked' ||
                    geography.properties.lastAction === 'markerDragged') &&
                geography.properties.zoom < 15,
            errorMessage: {
                fr: 'Le positionnement du lieu n\'est pas assez précis. Utilisez le zoom + pour vous rapprocher davantage, puis précisez la localisation en déplaçant l\'icône.',
                en: 'The positioning of the place is not precise enough. Please use the + zoom and drag the icon marker to confirm the precise location.'
            }
        },
        {
            validation: geography && geography.properties.isGeocodingImprecise,
            errorMessage: {
                fr: `<strong>Le nom du lieu utilisé pour effectuer la recherche ${!(0, LodashExtensions_1._isBlank)(geocodingTextInput) ? `("${geocodingTextInput}")` : ''} n'est pas assez précis.</strong> Ajoutez de l'information ou précisez l'emplacement à l'aide de la carte.`,
                en: `<strong>The location name used for searching ${!(0, LodashExtensions_1._isBlank)(geocodingTextInput) ? `("${geocodingTextInput}")` : ''} is not specific enough.</strong> Please add more information or specify the location more precisely using the map.`
            }
        },
        ...(0, exports.inaccessibleZoneGeographyCustomValidation)(geography, undefined, interview, path)
    ];
};
exports.getGeographyCustomValidation = getGeographyCustomValidation;
const householdElectricCarCountCustomValidation = (value, _customValue, interview) => {
    const carNumber = surveyHelperNew.getResponse(interview, 'household.carNumber', 0);
    const pluginHybridCarNumber = surveyHelperNew.getResponse(interview, 'household.pluginHybridCarNumber', 0);
    return [
        {
            validation: !(0, LodashExtensions_1._isBlank)(value) &&
                (typeof value === 'string' ? parseInt(value) : value) + pluginHybridCarNumber > carNumber,
            errorMessage: (t) => t('customLabel:HybridElectricExceedsTotal')
        }
    ];
};
exports.householdElectricCarCountCustomValidation = householdElectricCarCountCustomValidation;
const householdHybridCarCountCustomValidation = (value, _customValue, interview) => {
    const carNumber = surveyHelperNew.getResponse(interview, 'household.carNumber', 0);
    const electricCarNumber = surveyHelperNew.getResponse(interview, 'household.electricCarNumber', 0);
    return [
        {
            validation: !(0, LodashExtensions_1._isBlank)(value) &&
                (typeof value === 'string' ? parseInt(value) : value) + electricCarNumber > carNumber,
            errorMessage: (t) => t('customLabel:HybridElectricExceedsTotal')
        }
    ];
};
exports.householdHybridCarCountCustomValidation = householdHybridCarCountCustomValidation;
const transitFareCustomValidation = (value, customValue, interview, path, customPath, user) => [
    ...(0, validations_1.requiredValidation)(value, customValue, interview, path, customPath, user),
    {
        validation: !(0, LodashExtensions_1._isBlank)(value) && value.length && value.length > 1 && value.includes('dontKnow'),
        errorMessage: (t) => t('household:errors.selectDontKnowWhenNoOtherChoiceSelected')
    },
    {
        validation: !(0, LodashExtensions_1._isBlank)(value) && value.length && value.length > 1 && value.includes('no'),
        errorMessage: (t) => t('household:errors.selectNoWhenNoOtherChoiceSelected')
    }
];
exports.transitFareCustomValidation = transitFareCustomValidation;
const oneOrMoreAndPreferNotToAnswerValidation = (value) => [
    {
        validation: (0, LodashExtensions_1._isBlank)(value) || !value.length || value.length < 1,
        errorMessage: (t) => t('household:errors.selectOneOrMoreAnswer')
    },
    {
        validation: !(0, LodashExtensions_1._isBlank)(value) && value.length > 1 && value.includes('preferNotToAnswer'),
        errorMessage: (t) => t('household:errors.selectPreferNotToAnswerWhenNoOtherChoiceSelected')
    }
];
const travelToPlaceCustomValidation = (value) => [
    ...oneOrMoreAndPreferNotToAnswerValidation(value),
    {
        validation: !(0, LodashExtensions_1._isBlank)(value) && value.length > 1 && value.includes('no'),
        errorMessage: (t) => t('household:errors.selectNoTravelWhenNoOtherChoiceSelected')
    }
];
exports.travelToPlaceCustomValidation = travelToPlaceCustomValidation;
const remoteWorkDaysCustomValidation = (value) => [
    ...oneOrMoreAndPreferNotToAnswerValidation(value),
    {
        validation: !(0, LodashExtensions_1._isBlank)(value) && value.length > 1 && value.includes('no'),
        errorMessage: (t) => t('household:errors.selectNoRemoteWorkWhenNoOtherChoiceSelected')
    }
];
exports.remoteWorkDaysCustomValidation = remoteWorkDaysCustomValidation;
// FIXME Cannot use the builtin `inputRangeValidation` as the validation implies the field is required. This is for optional range inputs.
const rangeOptionalOrValidCustomValidation = (value) => {
    return [
        {
            // Check if the value is set and less than 0
            validation: !(0, LodashExtensions_1._isBlank)(value) && !(Number(value) >= 0),
            errorMessage: (t) => t('end:errors.inputRangeMustBePositiveOrZero')
        }
    ];
};
exports.rangeOptionalOrValidCustomValidation = rangeOptionalOrValidCustomValidation;
const inaccessibleZoneGeographyCustomValidation = (geography) => {
    return [
        {
            validation: geography &&
                ((0, turf_1.booleanPointInPolygon)(geography, inaccessibleZones_json_1.default.features[0]) ||
                    (0, turf_1.booleanPointInPolygon)(geography, quebecWaterWaysSimplified_json_1.default.features[0])),
            errorMessage: (t) => t('survey:visitedPlace:locationIsNotAccessibleError')
        }
    ];
};
exports.inaccessibleZoneGeographyCustomValidation = inaccessibleZoneGeographyCustomValidation;
